module.exports = __webpack_public_path__ + "img/Exams.93010c19.svg";